import { useCallback, useEffect, useState } from "react";

export default function useBWKLSchedule({ endpoint, trigger = true }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [resultingData, setResultingData] = useState([]);

  const fetchData = useCallback(
    async function () {
      setLoading(true);
      try {
        const response = await fetch(endpoint, {
          method: "GET",
          credentials: "include",
        });
        const result = await response.json();
        const resultData = result?.data || [];
        setData(result);
        setResultingData(resultData);
      } catch (error) {
        alert("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    },
    [endpoint],
  );
  useEffect(
    function () {
      if (trigger) {
        fetchData();
      }
    },
    [trigger, fetchData],
  );

  return [data, loading, resultingData];
}
